import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AddLabelsComponent} from './components/add-labels/add-labels.component';
import {AiChatPanelComponent} from './components/ai-chat-panel/ai-chat-panel.component';
import {DataTableComponent} from './components/data-table/data-table.component';
import {ColumnComponent} from './components/data-table/column/column.component';
import {ExpandableRowComponent} from './components/data-table/expandable-row/expandable-row.component';
import {InteractiveThComponent} from './components/data-table/interactive-th/interactive-th.component';
import {DialogComponent} from './components/dialog/dialog.component';
import {ErrorStripComponent} from './components/error-strip/error-strip.component';
import {HelpPopoverComponent} from './components/help-popover/help-popover.component';
import {HelpfulLabelComponent} from './components/helpful-label/helpful-label.component';
import {LabelsPopoverComponent} from './components/labels-popover/labels-popover.component';
import {OrganizationActionsComponent} from './components/organization-actions/organization-actions.component';
import {PanelHeaderComponent} from './components/panel-header/panel-header.component';
import {ResourcePathTypeComponent} from './components/resource-path-type/resource-path-type.component';
import {SideDialogComponent} from './components/side-dialog/side-dialog.component';
import {StatusComponent} from './components/status/status.component';
import {
    ActionSheetComponent,
    BarComponent,
    BarElementDirective,
    BarLeftDirective,
    BarRightDirective,
    BusyIndicatorModule,
    ButtonBarComponent,
    ButtonComponent,
    CheckboxModule, ComboboxComponent,
    DatePickerModule,
    DialogBodyComponent, DialogCloseButtonComponent,
    DialogComponent as FdDialogComponent,
    DialogFooterComponent,
    DialogFullScreenTogglerButtonComponent,
    DialogHeaderComponent,
    DialogTemplateDirective,
    DialogTitleDirective,
    FormControlComponent,
    FormInputMessageGroupComponent,
    FormItemComponent,
    FormLabelComponent,
    FormMessageComponent,
    IconModule,
    InputGroupModule,
    LinkModule,
    ListModule,
    MenuModule,
    MessageStripModule,
    MessageToastModule,
    MultiInputComponent,
    ObjectStatusComponent,
    OptionComponent,
    PaginationModule,
    PanelComponent, PanelTitleDirective,
    PopoverModule,
    RadioButtonComponent,
    ScrollbarDirective,
    SelectModule,
    TableModule,
    TabsModule,
    TemplateDirective,
    TextModule,
    TitleComponent,
    ToolbarModule,
    WizardComponent,
    WizardContentComponent,
    WizardNavigationComponent, WizardNextStepComponent,
    WizardProgressBarDirective,
    WizardStepComponent,
    WizardStepIndicatorComponent
} from "@fundamental-ngx/core";
import {FilterOnProjectPipe} from './pipes/filter-on-project/filter-on-project.pipe';
import {FilterOnSearchPipe} from './pipes/filter-on-search/filter-on-search.pipe';
import {SortByPipe} from './pipes/sort/sort-pipe';
import {PolicyFilterPipe} from './pipes/policy-filter/policy-filter.pipe';
import {GroupByPipe} from './pipes/group-by/group-by.pipe';
import {NestedValuePipe} from './pipes/nested-value/nested-value.pipe';
import {DynamicPipe} from './pipes/dynamic/dynamic.pipe';
import {FilterByFilterItemsPipe} from './pipes/filter-by-filter-items/filter-by-filter-items.pipe';
import {PaginationPipe} from './pipes/pagination/pagination.pipe';
import {CustomDatePipe} from './pipes/custom-date/custom-date.pipe';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TablePersonalizationComponent} from './components/table-personalization/table-personalization.component';
import {FilterDialogComponent} from './dialogs/filter-dialog/filter-dialog.component';
import {
    TablePersonalizationDialogComponent
} from './dialogs/table-personalization-dialog/table-personalization-dialog.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {DateComponent} from './components/date/date.component';
import {FilterByPipe} from './pipes/filter-by/filter-by.pipe';
import {RolesPopoverComponent} from './components/roles-popover/roles-popover.component';
import {ShowColumnsPipe} from './pipes/shown-columns/show-columns.pipe';
import {JsonEditorComponent} from './components/json-editor/json-editor.component';
import {TableActionsComponent} from './components/table-actions/table-actions.component';
import {ResetFilterBtnComponent} from './components/reset-filter-btn/reset-filter-btn.component';
import {SortByFixedPipe} from './pipes/sort-by-fixed/sort-by-fixed.pipe';
import {SearchFieldComponent} from './components/search-field/search-field.component';
import {PanelExpandableComponent} from './components/panel-expandable/panel-expandable.component';
import {FormlyModule} from '@ngx-formly/core';
import {ShowParentDataBtnComponent} from "./components/show-parent-data-btn/show-parent-data-btn.component";
import {ContainerComponent} from './components/container/container.component';
import {IconComponent} from './components/icon/icon.component';
import {FaModule} from "../core/font-awesome/fa.module";
import {ResourceGlyphPipe} from './pipes/resource-glyph/resource-glyph.pipe';
import {CdkScrollable, ScrollingModule} from "@angular/cdk/scrolling";
import {WizardDialogComponent} from "./components/wizard-dialog/wizard-dialog.component";
import {WizardSideDialogComponent} from "./components/wizard-side-dialog/wizard-side-dialog.component";
import {WizardDialogStepComponent} from "./components/wizard-dialog/wizard-dialog-step/wizard-dialog-step.component";
import {ReactiveInputComponent} from "./components/reactive-input/reactive-input.component";
import {ConfirmationDialogComponent} from './dialogs/confirmation-dialog/confirmation-dialog.component';
import {RouterModule} from "@angular/router";
import {FeatureTogglePipe} from "./pipes/feature-toggle/feature-toggle.pipe";
import {ReactiveEditInPlaceComponent} from "./components/reactive-edit-in-place/reactive-edit-in-place.component";
import {FullScreenButtonComponent} from "./components/full-screen-button/full-screen-button.component";
import {FullscreenHeadComponent} from "./components/fullscreen-head/fullscreen-head.component";
import {DisableControlDirective} from "./directives/disable-control.directive";
import {InfoMessageStripComponent} from './components/info-strip/info-strip.component';
import {AdvancedSearchComponent} from './components/advanced-search/advanced-search.component';
import {SavedFilterViewsComponent} from './components/saved-filter-views/saved-filter-views.component';
import {SaveFilterViewDialogComponent} from './dialogs/save-filter-view-dialog/save-filter-view-dialog.component';
import {ManageFilterViewsDialogComponent} from './dialogs/manage-filter-views-dialog/manage-filter-views-dialog.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    providers: [
        SortByPipe,
        FilterByFilterItemsPipe,
        DynamicPipe,
        SortByFixedPipe
    ],
    declarations: [
        AddLabelsComponent,
        AiChatPanelComponent,
        DataTableComponent,
        ColumnComponent,
        ExpandableRowComponent,
        InteractiveThComponent,
        DialogComponent,
        ErrorStripComponent,
        HelpPopoverComponent,
        HelpfulLabelComponent,
        LabelsPopoverComponent,
        OrganizationActionsComponent,
        PanelHeaderComponent,
        ResourcePathTypeComponent,
        SideDialogComponent,
        StatusComponent,
        FilterOnProjectPipe,
        FilterOnSearchPipe,
        SortByPipe,
        PolicyFilterPipe,
        GroupByPipe,
        NestedValuePipe,
        DynamicPipe,
        FilterByFilterItemsPipe,
        PaginationPipe,
        CustomDatePipe,
        TablePersonalizationComponent,
        FilterDialogComponent,
        TablePersonalizationDialogComponent,
        DateComponent,
        FilterByPipe,
        RolesPopoverComponent,
        ShowColumnsPipe,
        JsonEditorComponent,
        TableActionsComponent,
        ResetFilterBtnComponent,
        SortByFixedPipe,
        SearchFieldComponent,
        PanelExpandableComponent,
        ShowParentDataBtnComponent,
        ContainerComponent,
        IconComponent,
        ResourceGlyphPipe,
        WizardDialogComponent,
        WizardSideDialogComponent,
        WizardDialogStepComponent,
        ReactiveInputComponent,
        ReactiveEditInPlaceComponent,
        ConfirmationDialogComponent,
        FeatureTogglePipe,
        FullScreenButtonComponent,
        FullscreenHeadComponent,
        DisableControlDirective,
        InfoMessageStripComponent,
        AdvancedSearchComponent,
        SavedFilterViewsComponent,
        SaveFilterViewDialogComponent,
        ManageFilterViewsDialogComponent
    ],
    imports: [
        CommonModule,
        ObjectStatusComponent,
        ButtonComponent,
        PopoverModule,
        TextModule,
        BarComponent,
        IconModule,
        PanelComponent,
        ActionSheetComponent,
        FormLabelComponent,
        MessageStripModule,
        FdDialogComponent,
        MenuModule,
        TableModule,
        PaginationModule,
        FormInputMessageGroupComponent,
        FormsModule,
        FormControlComponent,
        FormMessageComponent,
        ListModule,
        DragDropModule,
        CheckboxModule,
        ToolbarModule,
        InputGroupModule,
        ReactiveFormsModule,
        FormlyModule,
        FaModule,
        ScrollingModule,
        FontAwesomeModule,
        BusyIndicatorModule,
        TabsModule,
        LinkModule,
        WizardComponent,
        RouterModule,
        MessageToastModule,
        ButtonBarComponent,
        DialogFooterComponent,
        DialogCloseButtonComponent,
        DialogBodyComponent,
        DialogHeaderComponent,
        TitleComponent,
        DialogTemplateDirective,
        DialogFooterComponent,
        CdkScrollable,
        ScrollbarDirective,
        ButtonComponent,
        ButtonBarComponent,
        DialogBodyComponent,
        DialogHeaderComponent,
        DialogTitleDirective,
        DialogFullScreenTogglerButtonComponent,
        BarElementDirective,
        BarLeftDirective,
        BarRightDirective,
        WizardProgressBarDirective,
        WizardContentComponent,
        WizardComponent,
        WizardNavigationComponent,
        WizardStepComponent,
        WizardStepIndicatorComponent,
        WizardNextStepComponent,
        PanelTitleDirective,
        TemplateDirective,
        SelectModule,
        OptionComponent,
        DatePickerModule,
        FormItemComponent,
        ComboboxComponent,
        MultiInputComponent,
        RadioButtonComponent
    ],
    exports: [
        AddLabelsComponent,
        AiChatPanelComponent,
        DataTableComponent,
        ColumnComponent,
        ExpandableRowComponent,
        InteractiveThComponent,
        DialogComponent,
        ErrorStripComponent,
        HelpPopoverComponent,
        HelpfulLabelComponent,
        LabelsPopoverComponent,
        OrganizationActionsComponent,
        PanelHeaderComponent,
        ResourcePathTypeComponent,
        SideDialogComponent,
        StatusComponent,
        FilterOnProjectPipe,
        FilterOnSearchPipe,
        SortByPipe,
        PolicyFilterPipe,
        GroupByPipe,
        NestedValuePipe,
        DynamicPipe,
        FilterByFilterItemsPipe,
        PaginationPipe,
        CustomDatePipe,
        TablePersonalizationComponent,
        FilterDialogComponent,
        TablePersonalizationDialogComponent,
        DateComponent,
        RolesPopoverComponent,
        JsonEditorComponent,
        TableActionsComponent,
        ResetFilterBtnComponent,
        SortByFixedPipe,
        SearchFieldComponent,
        PanelExpandableComponent,
        ShowParentDataBtnComponent,
        ContainerComponent,
        IconComponent,
        ResourceGlyphPipe,
        FilterByPipe,
        WizardDialogComponent,
        WizardSideDialogComponent,
        WizardDialogStepComponent,
        ReactiveInputComponent,
        ReactiveEditInPlaceComponent,
        FeatureTogglePipe,
        FullScreenButtonComponent,
        FullscreenHeadComponent,
        DisableControlDirective,
        InfoMessageStripComponent,
        AdvancedSearchComponent,
        SavedFilterViewsComponent,
        SaveFilterViewDialogComponent,
        ManageFilterViewsDialogComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
